import React from 'react';
import './App.css';
import { BrowserRouter as Router,Routes, Route } from 'react-router-dom';
import Navbar from './componets/navbar';
import Cart from './pages/cart/cart';
import Footer from './componets/footer/footer';
import { ShopContextProvider } from './componets/context/shopContext';
import Checkout from './pages/checkout/checkout';
import Rangoli from './pages/shop/rangoli';
import MatRangoli from './pages/shop/matRangoli';
import Diwali from './pages/shop/diwali';
import Chocolates from './pages/shop/chocolates';

function App() {
  return (
    <div className="App">
      <ShopContextProvider>
        <Router>
        <Navbar/>
            <Routes>
              <Route path='/' element={<Rangoli/>}/>
              <Route path='/matRangoli' element={<MatRangoli/>}/>
              <Route path='/diwali' element={<Diwali/>}/>
              <Route path='/chocolates' element={<Chocolates/>}/>
              <Route path='/cart' element={<Cart/>}/>
              <Route path='/checkout' element={<Checkout/>}/>
            </Routes>
        </Router>
        <Footer/>
      </ShopContextProvider>
    </div>
  );
}

export default App;

